import { useEffect } from 'react';

import {
  httpMethods,
  IGeneralRequestResponse,
  IHttpClientResponse,
  useHttpClientAsync,
} from '@services/httpClientService';
import { nonAwaitedPromiseHandler } from '@utils/async';

import { ApiSectionNamespace } from '../apiConstants';

import { mappingFunction } from './mapper';
import { IValidationRule } from './model';

export const useGetValidationRulesOnRender = (): IHttpClientResponse<IValidationRule, null> => {
  const asyncRequest = useHttpClientAsync<IValidationRule, null, IGeneralRequestResponse<IValidationRule>>({
    method: httpMethods.GET,
    path: ApiSectionNamespace.EDeliveryApiKeys.GET_VALIDATION_RULES_BY_COUNTRY,
    mappingFunction,
  });

  const { request } = asyncRequest;

  useEffect(() => {
    nonAwaitedPromiseHandler(request);
  }, [request]);

  return asyncRequest;
};
